interface PhotoSources {
  thumbUrl?: string | null;
  thumbUrl240?: string | null;
  imageUrl?: string;
  photoUrl?: string;
}

// The smallest photo that is sharp at `size` px: the 96px thumbnail for avatars up to
// 48px (2x screens), the 240px one up to 120px, else the original
export const photoFor = (m: PhotoSources, size: number): string | undefined => {
  const original = m.imageUrl || m.photoUrl || undefined;
  if (size <= 48) return m.thumbUrl || m.thumbUrl240 || original;
  if (size <= 120) return m.thumbUrl240 || original;
  return original;
};

// Initials for an avatar: first letter of the first and last words
// ("יצחק זאב פינדרוס" → "יפ"). Replaces the per-page getInitials copies.
export const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].charAt(0);
  return words[0].charAt(0) + words[words.length - 1].charAt(0);
};
